var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-full-wrapper",class:{
    blur: _vm.blur,
    transparent: _vm.transparent,
    closed: _vm.state === _vm.STATE_CLOSED,
    closing: _vm.state === _vm.STATE_CLOSING,
    opening: _vm.state === _vm.STATE_OPENING,
    opened: _vm.state === _vm.STATE_OPENED,
  },style:({
    'z-index': _vm.zIndex,
  }),on:{"click":function($event){if($event.target !== $event.currentTarget)return null;return (e => _vm.$emit('click', e)).apply(null, arguments)}}},[(!_vm.destroyOnClose || (_vm.destroyOnClose && _vm.state !== _vm.STATE_CLOSED))?_vm._t("default"):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }